<template>
  <v-container
    id="clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div>
      <v-row>
        <v-col
          cols="12"
          class="container"
        >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <dashboard-filtros
                :vendedores="enableVendedores"
                :redes="enableRedes"
                :meses="enableMeses"
                :anos="enableAnos"
                :supervisores="enableSupervisores"
                :btn1="enableBtn"
              />
            </v-col>
          </v-row>
          <v-row id="analiseFaturamentoFltrosId">
            <v-col
              cols="12"
              sm="2"
              md="2"
              lg="2"
            >
              <v-row v-if="enableBtnPrint">
                <v-btn
                  id="btnPrint"
                  class="col-12 col-sm-12 col-md-12 col-lg-12"
                  small
                  :color="corPrimaria"
                  dark
                  :loading="imprimindo"
                  @click="imprimir()"
                >
                  <v-icon>
                    mdi-printer
                  </v-icon>
                  Imprimir
                  <template v-slot:loader>
                    <span>Imprimindo...</span>
                  </template>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-row id="bloco1Print">
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="3"
            >
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'295'"
                    :text="'Faturamento - R$'"
                    :texto-information="textoFat"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamento"
                    :padding="dynamicPaddingAnaliseFaturamento1"
                    :loading="loadingFaturamento"
                  />
                </v-col>
                <v-col
                  id="componenteAnaliseProduto"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'101'"
                    :text="'Meta'"
                    :texto-information="textoMeta"
                    :style-object="styleObjectMeta"
                    :componente-valor="true"
                    :valor="`${valorMeta} (${porcentagemFaturamento}%)`"
                    :padding="dynamicPaddingAnaliseFaturamento1"
                    :loading="loadingMeta"
                  />
                </v-col>
                <v-col
                  id="componenteAnaliseProduto"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :text="'Devoluções - R$'"
                    :exibir-informacao="false"
                    :style-object="styleObjectDevolucao"
                    :componente-valor="true"
                    :valor="`${valorDevolucao} (${porcentagemDevolucao}%)`"
                    :padding="dynamicPaddingAnaliseFaturamento5"
                    :loading="loadingDevolucao"
                  />
                </v-col>
                <v-col
                  id="componenteAnaliseProduto"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :text="'Orçado'"
                    :exibir-informacao="false"
                    :style-object="styleObjectDevolucao"
                    :componente-valor="true"
                    :valor="`${valorOrcado}%`"
                    :padding="dynamicPaddingAnaliseFaturamento5"
                    :loading="loadingOrcado"
                  />
                </v-col>
                <v-col
                  id="componenteAnaliseProduto"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :text="'KG Total Faturamento'"
                    :exibir-informacao="false"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="`${valorKgFaturado} kg`"
                    :padding="dynamicPaddingAnaliseFaturamento5"
                    :loading="loadingKgFaturado"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="3"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'296'"
                :text="'Faturamento por Classificação - R$'"
                :texto-information="textoFatClassificacao"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartFaturamentoLinha'"
                :dados-grafico="chartBarFaturamentoLinha"
                :titulo-id="'myChartFaturamentoLinha'"
                :legenda-grafico="legendaGraficoFaturamentoLinha"
                :exibir-legenda="true"
                :padding="dynamicPaddingAnaliseFaturamento2"
                :loading="loadingFaturamentoLinha"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="3"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'297'"
                :text="'KG Total por Classificação - R$'"
                :texto-information="textoKgClassificacao"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartFaturamentoKgLinha'"
                :dados-grafico="chartBarFaturamentoKgLinha"
                :titulo-id="'myChartFaturamentoKgLinha'"
                :exibir-legenda="true"
                :padding="dynamicPaddingAnaliseFaturamento2"
                :loading="loadingFaturamentoKgLinha"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="3"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'298'"
                :text="'Preço Médio por Classificação - R$'"
                :texto-information="textoPrecoMedioClassificacao"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartFaturamentoPrecoMedio'"
                :dados-grafico="chartBarFaturamentoPrecoMedio"
                :titulo-id="'myChartFaturamentoPrecoMedio'"
                :exibir-legenda="true"
                :padding="dynamicPaddingAnaliseFaturamento2"
                :loading="loadingFaturamentoPrecoMedio"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              id="componenteAnaliseFaturamentoTable"
              cols="12"
              sm="12"
              md="12"
              lg="6"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Faturamento por Classificação por Mês - R$
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('299')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-table-faturamento-classificacao-mes />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              id="componenteAnaliseFaturamento"
              cols="12"
              sm="12"
              md="12"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'300'"
                :text="'Comparativo Faturamento - R$'"
                :texto-information="textoFatxFatAnterior"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartComparativoFaturamentoMes'"
                :dados-grafico="chartBarComparativoFaturamentoMes"
                :titulo-id="'myChartComparativoFaturamentoMes'"
                :exibir-legenda="true"
                :legenda-grafico="legendaGraficoComparativoFaturamentoMes"
                :padding="dynamicPaddingAnaliseFaturamento4"
                :loading="loadingFaturamentoMes"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row><br>

      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
    </div>
  </v-container>
</template>

<script>
  import Permissao from '../../../../services/menu'
  import Comercial from '../../../../services/comercialpersonalizacao'
  import eventEmit from '../../components/core/EventoEmit'
  import Chart from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels'
  import html2canvas from 'html2canvas'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardCliente',
    emits: ['setUpdateFiltros', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltros: () => import('../../components/core/FiltrosSaborDaSerra'),
      DashoardCardView: () => import('../../components/core/CardView'),
      ShowTableFaturamentoClassificacaoMes: () => import('../../components/comercial/comercialPersonalizado/TableFaturamentoClassificacaoMes'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleTexto: {
        color: '#00796B',
      },
      styleObjectMeta: {
        color: '#ed934f',
      },
      styleObjectDevolucao: {
        color: '#C62828',
      },
      paginaEnable: false,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      redes: [],
      ano: [],
      mes: [],
      supervisores: [],
      permissaoAnaliseFaturamento: false,
      enableVendedores: false,
      enableRedes: true,
      enableMeses: true,
      enableAnos: true,
      enableBtn: true,
      enableSupervisores: true,
      enableBtnPrint: false,
      codigo: 0,
      orientacao: [],
      textoFat: '',
      textoFatClassificacao: '',
      textoKgClassificacao: '',
      textoPrecoMedioClassificacao: '',
      textoFatClassificacaoMes: '',
      textoFatxFatAnterior: '',
      textoMeta: '',
      codigoIds: ['101', '295', '296', '297', '298', '299', '300'],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      myChart: {},
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorMeta: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      porcentagemFaturamento: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      porcentagemDevolucao: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      valorDevolucao: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorOrcado: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      valorKgFaturado: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      colorsFaturamentoLinha: [],
      legendaGraficoFaturamentoLinha: [],
      chartBarFaturamentoLinha: {},
      porcentagemFatLinha: [],
      chartBarFaturamentoKgLinha: {},
      coresChartFaturamentoKgLinha: [],
      chartBarFaturamentoPrecoMedio: {},
      coresChartFaturamentoPrecoMedio: [],
      chartBarComparativoFaturamentoMes: {},
      legendaGraficoComparativoFaturamentoMes: [
        { status: 'Faturamento', cor: '#4780b8' },
        { status: 'Faturamento Anterior', cor: '#cadaed' },
      ],
      dynamicPaddingAnaliseFaturamento1: '',
      dynamicPaddingAnaliseFaturamento2: '',
      dynamicPaddingAnaliseFaturamento3: '',
      dynamicPaddingAnaliseFaturamento4: '',
      dynamicPaddingAnaliseFaturamento5: '',
      loadingFaturamento: false,
      loadingMeta: false,
      loadingDevolucao: false,
      loadingOrcado: false,
      loadingKgFaturado: false,
      loadingFaturamentoLinha: false,
      loadingFaturamentoKgLinha: false,
      loadingFaturamentoPrecoMedio: false,
      loadingFaturamentoMes: false,
      imprimindo: false,
      headersImpressao: [],
      tableImpressao: [],
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('update-dados-filtros', this.handleUpdateDados)

      eventEmit.$on('enable-btn-print', this.handleBtnPrint)

      eventEmit.$on('enviar-table', this.tablePrint)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-filtros', this.handleUpdateDados)

      eventEmit.$off('enable-btn-print', this.handleBtnPrint)

      eventEmit.$off('enviar-table', this.tablePrint)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Análise Faturamento')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingAnaliseFaturamento1 = 'padding-right: 16.5rem !important'

          this.dynamicPaddingAnaliseFaturamento2 = 'padding-right: 11rem !important'

          this.dynamicPaddingAnaliseFaturamento3 = 'padding-right: 40rem !important'

          this.dynamicPaddingAnaliseFaturamento4 = 'padding-right: 45rem !important'

          this.dynamicPaddingAnaliseFaturamento5 = 'padding-right: 18rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingAnaliseFaturamento1 = 'padding-right: 10.5rem !important'

          this.dynamicPaddingAnaliseFaturamento2 = 'padding-right: 6rem !important'

          this.dynamicPaddingAnaliseFaturamento3 = 'padding-right: 29rem !important'

          this.dynamicPaddingAnaliseFaturamento4 = 'padding-right: 29rem !important'

          this.dynamicPaddingAnaliseFaturamento5 = 'padding-right: 12rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingAnaliseFaturamento1 = 'padding-right: 6rem !important'

          this.dynamicPaddingAnaliseFaturamento2 = 'padding-right: 6rem !important'

          this.dynamicPaddingAnaliseFaturamento3 = 'padding-right: 6rem !important'

          this.dynamicPaddingAnaliseFaturamento4 = 'padding-right: 6rem !important'

          this.dynamicPaddingAnaliseFaturamento5 = 'padding-right: 6rem !important'
        } else {
          this.dynamicPaddingAnaliseFaturamento1 = 'padding-right: 9rem !important'

          this.dynamicPaddingAnaliseFaturamento2 = 'padding-right: 8rem !important; margin: -1rem 0 0 -1rem'

          this.dynamicPaddingAnaliseFaturamento3 = 'padding-right: 20rem !important'

          this.dynamicPaddingAnaliseFaturamento4 = 'padding-right: 26rem !important'

          this.dynamicPaddingAnaliseFaturamento5 = 'padding-right: 10.4rem !important; margin: -1rem 0 0 -1rem;'
        }
      },

      handleUpdateDados (vendedor, redes, mes, ano, supervisor) {
        this.redes = redes
        this.mes = mes
        this.ano = ano
        this.supervisores = supervisor

        this.updateDate()
      },

      tablePrint (header, table) {
        this.headersImpressao = header

        this.tableImpressao = table
      },

      async updateDate () {
        try {
          this.enableBtnPrint = false

          this.headersImpressao = []

          this.tableImpressao = []

          eventEmit.$emit('set-update-filtros', this.redes, this.mes, this.ano, this.supervisores)

          this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          this.valorMeta = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          this.porcentagemFaturamento = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          this.valorDevolucao = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          this.valorOrcado = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          this.porcentagemDevolucao = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          this.valorKgFaturado = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

          if (this.chartBarFaturamentoLinha.data) {
            this.chartBarFaturamentoLinha.destroy()
          }

          if (this.chartBarFaturamentoKgLinha.data) {
            this.chartBarFaturamentoKgLinha.destroy()
          }

          if (this.chartBarFaturamentoPrecoMedio.data) {
            this.chartBarFaturamentoPrecoMedio.destroy()
          }

          if (this.chartBarComparativoFaturamentoMes.data) {
            this.chartBarComparativoFaturamentoMes.destroy()
          }

          this.loadingFaturamento = true
          this.loadingMeta = true
          this.loadingDevolucao = true
          this.loadingOrcado = true
          this.loadingKgFaturado = true
          this.loadingFaturamentoLinha = true
          this.loadingFaturamentoKgLinha = true
          this.loadingFaturamentoPrecoMedio = true
          this.loadingFaturamentoMes = true

          await Comercial.showFat(this.redes, this.mes, this.ano, this.supervisores, localStorage.tokencontrato).then(resposta => {
            if (resposta.data.status) {
              this.valorFaturamento = resposta.data.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

              this.valorMeta = resposta.data.valorMeta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

              this.porcentagemFaturamento = resposta.data.porcentagem
            } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
              this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

              this.valorMeta = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

              this.porcentagemFaturamento = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

              this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.error = 'Network Error'
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            } else if (e.data.text === 'Datas não conferem') {
              this.error = e.data.msg
              this.showSnackbar('error', 3000, e.data.msg)
            } else if (e.data.text === 'Empresa não encontrada') {
              this.error = e.data.text
              this.showSnackbar('error', 3000, 'Empresa não encontrada')
            }
          }).finally(f => { this.loadingFaturamento = false; this.loadingMeta = false })

          await Comercial.showFatDevolucao(this.redes, this.mes, this.ano, this.supervisores, localStorage.tokencontrato).then(resposta => {
            if (resposta.data.status) {
              this.valorDevolucao = resposta.data.valorDevolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

              this.valorOrcado = resposta.data.valorOrcado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

              this.porcentagemDevolucao = resposta.data.porcentagem
            } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
              this.valorDevolucao = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

              this.valorOrcado = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

              this.porcentagemDevolucao = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

              this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.error = 'Network Error'
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            } else if (e.data.text === 'Datas não conferem') {
              this.error = e.data.msg
              this.showSnackbar('error', 3000, e.data.msg)
            } else if (e.data.text === 'Empresa não encontrada') {
              this.error = e.data.text
              this.showSnackbar('error', 3000, 'Empresa não encontrada')
            }
          }).finally(f => { this.loadingDevolucao = false; this.loadingOrcado = false })

          await Comercial.showKgFaturados(this.redes, this.mes, this.ano, this.supervisores, localStorage.tokencontrato).then(resposta => {
            if (resposta.data.status) {
              this.valorKgFaturado = resposta.data.kilosFaturados.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
              this.valorKgFaturado = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

              this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.error = 'Network Error'
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loadingKgFaturado = false })

          await Comercial.showGraficoFaturamentoLinha(this.redes, this.mes, this.ano, this.supervisores, localStorage.tokencontrato).then(resposta => {
            if (resposta.data.status) {
              this.exibirLegenda = true

              this.legendaGraficoFaturamentoLinha = resposta.data.cores

              for (var i = 0; i < resposta.data.cores.length; i++) {
                const cor = resposta.data.cores[i].cor

                this.colorsFaturamentoLinha.push(cor)
              }

              const porcentagemLinha = resposta.data.porcentagem

              const ctx = document.getElementById('myChartFaturamentoLinha').getContext('2d')

              this.chartBarFaturamentoLinha = new Chart(ctx, {
                type: 'doughnut',
                data: {
                  labels: resposta.data.labels,
                  datasets: [
                    {
                      label: 'Faturamento',
                      data: resposta.data.faturamento,
                      backgroundColor: this.colorsFaturamentoLinha,
                    },
                  ],
                },
                options: {
                  legend: {
                    display: false,
                  },
                  responsive: true,
                  cutoutPercentage: 70,
                  tooltips: {
                    callbacks: {
                      label: (tooltipItem, data) => {
                        const porcentagem = porcentagemLinha[tooltipItem.index]

                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) + ' - ' + porcentagem + ' %'
                      },
                      title: (tooltipItem) => {
                        return resposta.data.labels[tooltipItem[0].index]
                      },
                    },
                  },
                },
              })
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.error = e.message
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
              if (this.chartBarFaturamentoLinha.data) {
                this.chartBarFaturamentoLinha.destroy()
              }

              this.title = false

              this.showSnackbar('error', 3000, e.data.msg)
            } else if (e.data.text === 'Empresa não encontrada') {
              if (this.chartBarFaturamentoLinha.data) {
                this.chartBarFaturamentoLinha.destroy()
              }

              this.title = false

              this.showSnackbar('error', 3000, e.data.text)
            } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
              if (this.chartBarFaturamentoLinha.data) {
                this.chartBarFaturamentoLinha.destroy()
              }

              this.showSnackbar('error', 3000, e.data.text)
            }
          }).finally(f => { this.loadingFaturamentoLinha = false })

          await Comercial.showGraficoFaturamentoKgLinha(this.redes, this.mes, this.ano, this.supervisores, localStorage.tokencontrato).then(resposta => {
            if (resposta.data.status) {
              for (var i = 0; i < resposta.data.cores.length; i++) {
                const cor = resposta.data.cores[i].cor

                this.coresChartFaturamentoKgLinha.push(cor)
              }

              const ctx = document.getElementById('myChartFaturamentoKgLinha').getContext('2d')

              this.chartBarFaturamentoKgLinha = new Chart(ctx, {
                plugins: [ChartDataLabels],
                type: 'horizontalBar',
                data: {
                  labels: resposta.data.labels,
                  datasets: [
                    {
                      label: 'Faturamento',
                      data: resposta.data.faturamento,
                      backgroundColor: this.coresChartFaturamentoKgLinha,
                    },
                  ],
                },
                options: {
                  scales: {
                    y: {
                      beginAtZero: true,
                    },
                    xAxes: [{
                      ticks: {
                        min: 0,
                      },
                      gridLines: {
                        display: false,
                      },
                      display: false,
                    }],
                    yAxes: [{
                      gridLines: {
                        display: false,
                      },
                      display: true,
                    }],
                  },
                  responsive: true,
                  legend: {
                    display: false,
                  },
                  tooltips: {
                    callbacks: {
                      label: (tooltipItem, data) => {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      },
                      title: (tooltipItem) => {
                        return resposta.data.labels[tooltipItem[0].index]
                      },
                    },
                  },
                  plugins: {
                    datalabels: {
                      display: true,
                      color: function (context) {
                        return '#000000'
                      },
                      font: {
                        size: 11,
                      },
                      formatter: (value) => {
                        return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      },
                      align: 'end',
                      offset: 4,
                    },
                  },
                },
              })
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.error = e.message
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
              if (this.chartBarFaturamentoKgLinha.data) {
                this.chartBarFaturamentoKgLinha.destroy()
              }

              this.showSnackbar('error', 3000, e.data.msg)
            } else if (e.data.text === 'Empresa não encontrada') {
              if (this.chartBarFaturamentoKgLinha.data) {
                this.chartBarFaturamentoKgLinha.destroy()
              }

              this.showSnackbar('error', 3000, e.data.text)
            } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
              if (this.chartBarFaturamentoKgLinha.data) {
                this.chartBarFaturamentoKgLinha.destroy()
              }

              this.showSnackbar('error', 3000, e.data.text)
            }
          }).finally(f => { this.loadingFaturamentoKgLinha = false })

          await Comercial.showGraficoFaturamentoPrecoMedio(this.redes, this.mes, this.ano, this.supervisores, localStorage.tokencontrato).then(resposta => {
            if (resposta.data.status) {
              for (var i = 0; i < resposta.data.cores.length; i++) {
                const cor = resposta.data.cores[i].cor

                this.coresChartFaturamentoPrecoMedio.push(cor)
              }

              const ctx = document.getElementById('myChartFaturamentoPrecoMedio').getContext('2d')

              this.chartBarFaturamentoPrecoMedio = new Chart(ctx, {
                plugins: [ChartDataLabels],
                type: 'horizontalBar',
                data: {
                  labels: resposta.data.labels,
                  datasets: [
                    {
                      label: 'Faturamento',
                      data: resposta.data.faturamento,
                      backgroundColor: this.coresChartFaturamentoPrecoMedio,
                    },
                  ],
                },
                options: {
                  scales: {
                    y: {
                      beginAtZero: true,
                    },
                    xAxes: [{
                      ticks: {
                        min: 0,
                      },
                      gridLines: {
                        display: false,
                      },
                      display: false,
                    }],
                    yAxes: [{
                      gridLines: {
                        display: false,
                      },
                      display: true,
                    }],
                  },
                  responsive: true,
                  legend: {
                    display: false,
                  },
                  tooltips: {
                    callbacks: {
                      label: (tooltipItem, data) => {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      },
                      title: (tooltipItem) => {
                        return resposta.data.labels[tooltipItem[0].index]
                      },
                    },
                  },
                  plugins: {
                    datalabels: {
                      display: true,
                      color: function (context) {
                        return '#000000'
                      },
                      font: {
                        size: 11,
                      },
                      formatter: (value) => {
                        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      },
                      align: 'end',
                      offset: 4,
                    },
                  },
                },
              })
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.error = e.message
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
              if (this.chartBarFaturamentoPrecoMedio.data) {
                this.chartBarFaturamentoPrecoMedio.destroy()
              }

              this.showSnackbar('error', 3000, e.data.msg)
            } else if (e.data.text === 'Empresa não encontrada') {
              if (this.chartBarFaturamentoPrecoMedio.data) {
                this.chartBarFaturamentoPrecoMedio.destroy()
              }

              this.showSnackbar('error', 3000, e.data.text)
            } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
              if (this.chartBarFaturamentoPrecoMedio.data) {
                this.chartBarFaturamentoPrecoMedio.destroy()
              }

              this.showSnackbar('error', 3000, e.data.text)
            }
          }).finally(f => { this.loadingFaturamentoPrecoMedio = false })

          await Comercial.showCompartivoFaturamentoMes(this.redes, this.mes, this.ano, this.supervisores, localStorage.tokencontrato).then(resposta => {
            if (resposta.data.status) {
              this.exibirLegenda = true

              const ctx = document.getElementById('myChartComparativoFaturamentoMes').getContext('2d')

              const isLargeScreen = window.innerWidth > 1380

              const baseFontSize = isLargeScreen ? 20 : 16
              const labelFontSize = isLargeScreen ? 20 : 14

              this.chartBarComparativoFaturamentoMes = new Chart(ctx, {
                plugins: [ChartDataLabels],
                type: 'bar',
                data: {
                  labels: resposta.data.labels,
                  datasets: [
                    {
                      label: 'Faturamento',
                      data: resposta.data.faturamento,
                      backgroundColor: '#4780b8',
                      order: 2,
                    },
                    {
                      label: 'Faturamento Anterior',
                      data: resposta.data.faturamentoAnterior,
                      backgroundColor: '#cadaed',
                      order: 1,
                    },
                    {
                      label: 'Porcentagem',
                      data: resposta.data.porcentagem,
                      type: 'line',
                      borderColor: 'transparent',
                      backgroundColor: 'transparent',
                      order: 3,
                    },
                  ],
                },
                options: {
                  plugins: {
                    datalabels: {
                      display: true,
                      color: function (context) {
                        if (context.dataset.label !== 'Porcentagem') {
                          return '#000000'
                        } else {
                          return 'transparent'
                        }
                      },
                      font: {
                        size: baseFontSize,
                      },
                      formatter: (value) => {
                        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      },
                      rotation: 270,
                      align: 'end',
                      offset: 4,
                    },
                  },
                  scales: {
                    y: {
                      beginAtZero: true,
                    },
                    xAxes: [{
                      gridLines: {
                        display: false,
                      },
                      ticks: {
                        display: true,
                        fontSize: labelFontSize,
                      },
                    }],
                    yAxes: [{
                      gridLines: {
                        display: false,
                      },
                      display: false,
                    }],
                  },
                  responsive: true,
                  legend: {
                    display: false,
                  },
                  tooltips: {
                    callbacks: {
                      label: (tooltipItem, data) => {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      },
                      title: (tooltipItem) => {
                        if (tooltipItem[0].datasetIndex === 0) {
                          return tooltipItem[0].xLabel + ' - ' + resposta.data.ano
                        } else {
                          var ano = resposta.data.ano - 1
                          return tooltipItem[0].xLabel + ' - ' + ano
                        }
                      },
                    },
                    titleFontSize: 16,
                    bodyFontSize: 16,
                  },
                },
              })
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.error = e.message
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
              if (this.chartBarComparativoFaturamentoMes.data) {
                this.chartBarComparativoFaturamentoMes.destroy()
              }

              this.showSnackbar('error', 3000, e.data.msg)
            } else if (e.data.text === 'Empresa não encontrada') {
              if (this.chartBarComparativoFaturamentoMes.data) {
                this.chartBarComparativoFaturamentoMes.destroy()
              }

              this.showSnackbar('error', 3000, e.data.text)
            } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
              if (this.chartBarComparativoFaturamentoMes.data) {
                this.chartBarComparativoFaturamentoMes.destroy()
              }

              this.showSnackbar('error', 3000, e.data.text)
            }
          }).finally(f => { this.loadingFaturamentoMes = false })
        } catch (error) {
          console.error('Erro ao buscar dados:', error)
        } finally {
          this.enableBtnPrint = true
        }
      },

      handleBtnPrint () {
        this.enableBtnPrint = true
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Definir a margem esquerda
          const marginLeftRem = -1
          const marginLeftPx = marginLeftRem * 16
          let posYFiltros = 10

          const title = 'Análise Faturamento'
          pdf.text(title, 105, posYFiltros)

          posYFiltros += 10
          const filtros = 'Filtros Selecionados:'
          pdf.setFontSize(10)
          pdf.text(filtros, 15, posYFiltros)

          const datas = this.mes[0].texto + ' - ' + this.ano
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisores.map(s => s.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 15, posY)
            posY += pdf.getTextDimensions(title).h /* + 5 */

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: fontSize, textColor: [0, 0, 0] } }))],
              body: data.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
              startY: posY,
              styles: { fontSize: fontSize },
            })

            posY = 20

            return posY
          }

          if (posYFiltros > 70) {
            pdf.addPage()

            posYFiltros = 10
          }

          // Adicionar a imagem dos filtros usando html2canvas
          const bloco1 = document.getElementById('bloco1Print')
          const canvasBloco1Print = await html2canvas(bloco1)
          const imgWidthBloco1 = 290
          const imgHeightBloco1 = (canvasBloco1Print.height * imgWidthBloco1) / canvasBloco1Print.width

          pdf.addImage(canvasBloco1Print.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthBloco1, imgHeightBloco1)

          posYFiltros += imgHeightBloco1

          pdf.addPage()
          posYFiltros = 10

          const titleTableGrupoProduto = 'Faturamento por Classificação por Mês - R$'
          const tableGrupoProduto = this.tableImpressao.map(item => {
            const values = Object.keys(item).filter(key => key !== 'familia_produto' && key !== 'classificacao_total')
            return ['familia_produto', ...values, 'classificacao_total'].map(key => item[key])
          })
          posYFiltros = await addTable(tableGrupoProduto, this.headersImpressao, titleTableGrupoProduto, posYFiltros, 8)

          pdf.addPage()
          posYFiltros = 10

          const bloco2 = document.getElementById('componenteAnaliseFaturamento')
          const canvasBloco2Print = await html2canvas(bloco2)
          const imgWidthBloco2 = 200
          const imgHeightBloco2 = (canvasBloco2Print.height * imgWidthBloco2) / canvasBloco2Print.width

          pdf.addImage(canvasBloco2Print.toDataURL('image/png'), 'PNG', 40 + marginLeftPx, posYFiltros, imgWidthBloco2, imgHeightBloco2)

          pdf.save('relatorio_analise_faturamento.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.faturamentoGrupoProdutosPrint = []
          this.faturamentoLinhaPrint = []
          this.headersTableLinha = []
          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }

</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #textoFaturamentoAnaliseFat {
      margin: 0 0 0 -8rem;
    }

    #componenteKgTotalIdAnaliseFaturamento {
      margin: 1rem 0 0 0;
    }

    #iconInformationFat {
      margin: -6.5rem 0 0 0;
    }

    #iconInformationFatClassificacao {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationKgClassificacao {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationPrecoMedioClassificacao {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationFatClassificacaoMes {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationFatxFatAnterior {
      margin: -6.8rem 0 0 0;
    }
  }

  @media screen
  and (min-width : 600px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

</style>

<style lang="sass">
  .hidden
    display: none

  #textoAnaliseFaturamento
    font-size: 36px
    margin: 1.5rem 0 0 0

  #textoFaturamentoAnaliseFat
    margin: 0 0 0 -7rem

  #btnPrint
    margin: 0.5rem 0 2rem 3rem

  #iconInformationPrecoMedioClassificacao
    maring: 0 0 0 -1rem

  #componenteKgTotalIdAnaliseFaturamento
      margin: 0 0 0 -2rem

  #componenteAnaliseProduto
    margin: -3rem 0 0 0

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemFaturamentoClassificacao
    margin: -2rem 0 0 -1rem

  #componenteAnaliseFaturamento
    margin: -3rem 0 0 0

  #componenteAnaliseFaturamentoTable
    margin: -3rem 0 0 0
</style>
